"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKRouterNavLink = void 0;
/* eslint-disable react/display-name */
var React = __importStar(require("react"));
var hooks_1 = require("../../../common/hooks");
/**
 * Variant of GKNavLink that renders a react-router NavLink as opposed to an <a> tag directly
 * @remarks
 * Note: if you're using react-router v6, you cannot pass a function to 'style' or 'className'
 * props, as it is this component's responsibility to style them and expect standard/default
 * active class name. If you'd like to style them yourself, use NavLink directly.
 */
var GKRouterNavLink = function () {
    return null;
};
exports.GKRouterNavLink = GKRouterNavLink;
try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var rrd_1 = require("react-router-dom");
    exports.GKRouterNavLink = function (props) {
        var mergedProps = (0, hooks_1.useMergedProps)(props, {
            _gkComponentIdentifier: "gk-router-nav-link",
            className: "nav-link",
        });
        return React.createElement(rrd_1.NavLink, __assign({}, mergedProps));
    };
}
catch (e) {
    window.console.error("GKRouterNavLink: react-router-dom not loaded!", e);
    exports.GKRouterNavLink = function () {
        window.console.warn("GKRouterNavLink: cannot render because of exception: ");
        var Link = React.createElement("span", null, "[GKRouterNavLink]");
        return Link;
    };
}
exports.default = exports.GKRouterNavLink;
